import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import config from '../../config';
import { isResearcher } from '../../utils/checkPermissions';
import { showError } from '../../utils/MessagePopup';
import connectOptions, { mergeProps } from '../../utils/connectOptions';
import { usePopupContext } from '../../contexts/PopupContext';

const ContactExecutiveCreateContainer = ({ user, history }) => {
  const { hasPopup, openPopup, closePopup } = usePopupContext();

  const hasAccess = () => {
    if (!user) return false;

    return !isResearcher(user.getIn(['roles', 0, 'slug'], null));
  };

  useEffect(() => {
    if (!user) return;

    if (!hasAccess()) {
      showError(openPopup, config.permisionError, () => {
        history.push('/');
        closePopup();
      });
    }

    if (hasPopup()) return;
    openPopup('AddExecutiveContactPopup');
  }, [user, hasPopup, openPopup, closePopup]);

  return <Helmet title="Create Executive Contact" />;
};

const mapStateToProps = state => ({
  user: state.auth.get('user', null),
});

export { ContactExecutiveCreateContainer };
export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(ContactExecutiveCreateContainer));
